import type { CostCenterFragment } from "@src/__generated__/graphql";

export const toCostCentersOptions = (costCenters: CostCenterFragment[]) => {
  return costCenters.map((center) => ({
    label: `${center.centre} - ${center.title}`,
    value: center.id,
    isDisabled: !!center.deleted_at,
  }));
};
